<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>{{$t('Login.RegisterComponent.title')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="valid">
        <v-text-field
          :rules="[rules.required]"
          v-model="username"
          :label="$t('Login.RegisterComponent.login')"
          name="username"
          prepend-icon="person"
          type="text"
          required
        ></v-text-field>
        <v-text-field
          :rules="[rules.required, rules.validateEmail]"
          v-model="mail"
          :label="$t('Login.RegisterComponent.mail')"
          name="mail"
          prepend-icon="mail"
          type="email"
          required
        ></v-text-field>
        <v-text-field
          :rules="[rules.required, rules.min, rules.max, rules.uppercase, rules.lowercase,rules.digit, rules.nospace]"
          v-model="password"
          :hint="$t('Login.RegisterComponent.password-hint')"
          counter
          id="password"
          :label="$t('Login.RegisterComponent.password')"
          name="password"
          prepend-icon="lock"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          required
        ></v-text-field>
        <v-text-field
          :rules="[rules.required, rules.min, rules.max, rules.uppercase, rules.lowercase,rules.digit, rules.nospace]"
          v-model="verifPassword"
          :hint="$t('Login.RegisterComponent.password-hint')"
          counter
          :label="$t('Login.RegisterComponent.verif')"
          prepend-icon="lock"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show2 ? 'text' : 'password'"
          @click:append="show2 = !show2"
          required
        ></v-text-field>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-alert
        v-if="passwordConfirmationRule()!=true"
        class="mb-2 ml-3"
        dense
        outlined
        type="error"
      >{{passwordConfirmationRule()}}</v-alert>
      <v-spacer></v-spacer>
      <v-btn
        class="mb-3 ml-3"
        color="primary"
        @click="register"
      >{{$t('Login.RegisterComponent.submit')}}</v-btn>
      <v-btn class="mr-3 mb-3" color="primary" @click="back">{{$t('Login.RegisterComponent.back')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: false,
      username: "",
      mail: "",
      password: "",
      verifPassword: "",
      show1: false,
      show2: false,
      rules: {
        required: value =>
          !!value || this.$t("Login.RegisterComponent.rules.required"),
        min: v => v.length >= 8 || this.$t("Login.RegisterComponent.rules.min"),
        max: v =>
          v.length <= 20 || this.$t("Login.RegisterComponent.rules.max"),
        uppercase: value =>
          /^(?=.*[A-Z])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.uppercase"),
        lowercase: value =>
          /^(?=.*[a-z])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.lowercase"),
        digit: value =>
          /^(?=.*[0-9])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.digit"),
        nospace: value =>
          /^\S+$/.test(value) ||
          this.$t("Login.RegisterComponent.rules.nospace"),
        validateEmail: value => {
          var re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
          return (
            re.test(String(value).toLowerCase()) ||
            this.$t("Login.RegisterComponent.rules.mail")
          );
        }
      }
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.password === this.verifPassword ||
        this.$t("Login.RegisterComponent.rules.match");
    }
  },
  methods: {
    register: function() {
      if (this.valid && this.passwordConfirmationRule() == true) {
        axios
          .post(process.env.VUE_APP_API_ADDR + "/api/user", {
            username: this.username,
            mail: this.mail,
            password: this.password
          })
          .then(res => {
            if (res.data.success) {
              this.$emit("registered");
            }
          })
          .catch(err => {
            switch (err.response.data.errorMessage) {
              default:
                this.$emit("alert", this.$t("Login.Alert.api-error"));
                break;
              case "Username is already used !":
                this.$emit("alert", this.$t("Login.Alert.username-error"));
                break;
              case "Mail is already used !":
                this.$emit("alert", this.$t("Login.Alert.mail-error"));
                break;
            }
          });
      } else {
        this.$emit("alert", this.$t("Login.Alert.form-error"));
      }
    },
    back: function() {
      this.$emit("back");
    }
  }
};
</script>